module.exports = __webpack_public_path__ + "img/null_data.5a4c6d96.png";